export default __webpack_public_path__ + "static/EnhanceChain-d4cf58bf4713c5f82272780b10874098.png";